import { DateTime } from "luxon";
import { ODataSelect } from "@iconics/core";
import { SyncronisationType } from "../../../../Providers.StaticData/StaticDataProvider";

export class IdentityProvider extends ODataSelect
{
    // common properties
    public Id = 0;
    public Name = '';
    public DisplayName = '';
    public SecurityProviderTypeId = 0;
    public IsDefault = false;
    public '@odata.etag' = '';

    // native properties
    public MinPasswordLength = 0;
    public MaxPasswordAge = 0;
    public PasswordComplexity = 0;

    // 3rd party properties
    public ClientId = '';
    public ClientSecret?= '';
    public TenantId = '';
    public TenantDomain = '';
    public NameClaimType = '';
    public AdditionalAudiences = '';
    public SyncType: SyncronisationType = 'None';
    public LastSync: DateTime | null = null;
    public LastSyncStatus = 0;
    public LastSyncInfo: ILastSyncInfo | null = null;
    public IdentityProviderId = '';
    public ScimSecurityToken = '';

    public toSelect(): string
    {
        return '';
    }

    public init(response: any, nodeId: number): IdentityProvider
    {
        Object.assign(this, response);
        const lastSync = DateTime.fromISO(response.LastSync);
        this.LastSync = (response.LastSync == null ? null : lastSync);
        try
        {
            this.LastSyncInfo = JSON.parse(response.LastSyncInfo);
        }
        catch
        {
            this.LastSyncInfo = null;
        }
        return this;
    }
}

export interface ILastSyncInfo
{
    Message: string;
    Groups: ILastSyncInfoGroup[]
}

export interface ILastSyncInfoGroup
{
    Id: string;
    Name: string
    UsersCount: number;
}

export interface INewIdentityProvider
{
    Id: number;
}

